var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import FactsHexagon from '@backrs_ui/common-ui/src/assets/images/facts-hexagon.svg';
import { Typography, Box } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import { ImageCard } from './ImageCard';
import { appStrings } from '../assets/appStrings';
var STRINGS = appStrings.modules.blueprint;
export function FactCard(_a) {
    var facts = _a.facts;
    var factsSection = (_jsx(Box, { sx: factsContainerSx, children: facts.map(function (info, index) { return (_jsx(ReactMarkdown, { components: {
                p: function (_a) {
                    var children = _a.children;
                    return (_jsx(Typography, { component: "p", sx: info.type === 'LINK' ? urlTextStyle : {}, onClick: info.type === 'LINK' ? function () { return window.open(info.url, '_blank'); } : undefined, variant: "text-sm-regular", children: children }, index));
                },
            }, children: info.value }, index)); }) }));
    return (_jsx(ImageCard, { imageUrl: FactsHexagon, title: STRINGS.didYouKnow, description: factsSection, sxOverrides: {
            container: container,
            imageWrapper: imageWrapper,
            title: title,
            titleDescChildContainer: titleDescChildContainer,
            image: image,
        } }));
}
var factsContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        gap: backrs.spacing['spacing-md'],
        paddingTop: backrs.spacing['spacing-xs'],
    });
};
var imageWrapper = function (_a) {
    var backrs = _a.backrs;
    return ({
        backgroundColor: backrs.colors['Error/400'],
        padding: backrs.spacing['spacing-3xl'],
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderBottom: "1px solid ".concat(backrs.colors['Colors/Base/Black']),
    });
};
var title = function (_a) {
    var backrs = _a.backrs, typography = _a.typography;
    return (__assign(__assign({}, typography['text-sm-medium']), { color: backrs.colors['Colors/Text/text-secondary'] }));
};
var container = {
    '&:hover': {
        boxShadow: 'none',
        transform: 'none',
    },
    cursor: 'default',
    '@media (max-width: 600px)': {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderBottom: 'none',
    },
};
var titleDescChildContainer = function (_a) {
    var backrs = _a.backrs;
    return ({
        padding: backrs.spacing['spacing-3xl'],
        '@media (max-width: 600px)': {
            paddingBottom: backrs.spacing['spacing-9xl'],
        },
    });
};
var image = {
    width: '100%',
    '@media (max-width: 600px)': {
        width: '210px',
    },
};
var urlTextStyle = {
    cursor: 'pointer',
    textDecoration: 'underline',
};
